import React, { useState } from "react";
import "./AdminLogin.css";
import axios from "axios";
import { ADMIN_API_BASE_URL } from "../Auth/Api";
import { useAuth } from "../Auth/useAuth";
import logo from '../Assets/logo.png';

function AdminLogin() {
  const { login } = useAuth();

  const [formData, setFormData] = useState({
    username: "",
    password: "",
    otp: "",
  });

  const [otpSent, setOtpSent] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });
  const [loading, setLoading] = useState(false);
  const [verifying, setVerifying] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: "", text: "" });

    console.log("🔹 handleLogin called!");
    console.log("🔹 Received formData:", formData);

    if (!formData || !formData.username || !formData.password) {
      console.error("❌ Missing username or password!", formData);
      setMessage({
        type: "error",
        text: "Please enter both username and password!",
      });
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(
        `${ADMIN_API_BASE_URL}/main/admin/login?username=${formData.username}&password=${formData.password}`,
        {},
        { headers: { "Content-Type": "application/json" } }
      );

      console.log("🔹 Login API Response:", response.data);

      if (
        response.data &&
        response.data.includes("OTP sent to registered mobile number")
      ) {
        setOtpSent(true);
        setMessage({
          type: "success",
          text: "An OTP has been sent to your registered mobile number.",
        });
      } else {
        setMessage({
          type: "error",
          text: response.data || "Invalid username or password.",
        });
      }
    } catch (error) {
      console.error("❌ Login Error:", error.response?.data?.message || error);
      setMessage({
        type: "error",
        text:
          error.response?.data?.message ||
          "Something went wrong. Please try again!",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleOtpVerification = async (e) => {
    e.preventDefault();
    setVerifying(true);
    setMessage({ type: "", text: "" });

    console.log("🔹 handleOtpVerification called!");
    console.log("🔹 Received formData:", formData);

    if (!formData || !formData.username || !formData.otp) {
      console.error("❌ Missing username or OTP!", formData);
      setMessage({
        type: "error",
        text: "Please enter both username and OTP!",
      });
      setVerifying(false);
      return;
    }

    try {
      const response = await axios.post(
        `${ADMIN_API_BASE_URL}/main/admin/verify-otp?username=${formData.username}&otp=${formData.otp}`,
        {}
      );

      console.log("🔹 OTP Verification API Response:", response.data);

      if (response.data && response.data.token) {
        const token = response.data.token;
        const admin = response.data.admin;

        localStorage.setItem("authToken", token);
        localStorage.setItem("admin", JSON.stringify(admin));

        login(token, admin);

        setMessage({
          type: "success",
          text: "Verification successful! Redirecting to the admin dashboard.",
        });
        
        // Small delay to show success message before redirect
        setTimeout(() => {
          window.location.href = "/admin/dashboard";
        }, 1500);
      } else {
        setMessage({
          type: "error",
          text: "The OTP you entered is incorrect. Please try again.",
        });
      }
    } catch (error) {
      console.error(
        "❌ OTP Verification Error:",
        error.response?.data?.message || error
      );
      setMessage({
        type: "error",
        text:
          error.response?.data?.message ||
          "Something went wrong. Please try again!",
      });
    } finally {
      setVerifying(false);
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-card">
        <div className="admin-login-left">
          <div className="admin-login-logo-container">
            <img 
              src={logo}
              alt="Company Logo" 
              className="admin-login-logo"
            />
            <div className="admin-login-welcome-text">
              <h2>Welcome Back!</h2>
              <p>Please login to continue to your admin dashboard</p>
            </div>
          </div>
        </div>

        <div className="admin-login-right">
          <div className="admin-login-form-container">
            {!otpSent ? (
              <>
                <h2 className="admin-login-title">Admin Login</h2>
                <form onSubmit={handleLogin}>
                  <div className="admin-form-group">
                    <label htmlFor="username" className="admin-form-label">
                      Username
                    </label>
                    <input
                      type="text"
                      className="admin-form-control"
                      id="username"
                      name="username"
                      value={formData.username}
                      onChange={handleChange}
                      required
                      disabled={loading}
                    />
                  </div>
                  <div className="admin-form-group">
                    <label htmlFor="password" className="admin-form-label">
                      Password
                    </label>
                    <input
                      type="password"
                      className="admin-form-control"
                      id="password"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      required
                      disabled={loading}
                    />
                  </div>
                  <button
                    type="submit"
                    className="admin-login-btn"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span className="admin-loading-spinner"></span>
                        Sending OTP...
                      </>
                    ) : (
                      "Send OTP"
                    )}
                  </button>
                </form>
              </>
            ) : (
              <>
                <h2 className="admin-login-title">OTP Verification</h2>
                <form onSubmit={handleOtpVerification}>
                  <div className="admin-form-group">
                    <label htmlFor="otp" className="admin-form-label">
                      Enter OTP
                    </label>
                    <input
                      type="text"
                      className="admin-form-control"
                      id="otp"
                      name="otp"
                      value={formData.otp}
                      onChange={handleChange}
                      required
                      disabled={verifying}
                    />
                  </div>
                  <button
                    type="submit"
                    className="admin-verify-btn"
                    disabled={verifying}
                  >
                    {verifying ? (
                      <>
                        <span className="admin-loading-spinner"></span>
                        Verifying...
                      </>
                    ) : (
                      "Verify OTP"
                    )}
                  </button>
                </form>
                
                {/* Back to login option */}
                <div className="admin-back-to-login">
                  <button
                    type="button"
                    className="admin-back-btn"
                    onClick={() => {
                      setOtpSent(false);
                      setMessage({ type: "", text: "" });
                    }}
                    disabled={verifying}
                  >
                    ← Back to Login
                  </button>
                </div>
              </>
            )}

            {message.text && (
              <div
                className={`admin-message admin-message-${message.type}`}
                role="alert"
              >
                {message.text}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminLogin;